import { Button } from '@/components/ui/button';
import { Shield, Github } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { BaseComponent } from '@/types';

/**
 * Why Choose Us Section Component
 * Explains the unique value proposition and team expertise
 */
export function WhyChooseUs({ className }: BaseComponent) {
  return (
    <section id="why-us" className={cn("py-20 bg-gradient-subtle", className)}>
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold">
            Why Choose NeurosEdge
          </h2>
          <p className="text-xl text-muted-foreground">
            Built by experts for experts, with security and efficiency at the core
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <img 
              src="/images/team-cybersec.jpg" 
              alt="Cybersecurity Experts" 
              className="rounded-2xl shadow-elegant w-full"
              loading="lazy"
            />
          </div>
          
          {/* Content */}
          <div className="space-y-8">
            {/* Security Feature */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Shield className="w-8 h-8 text-primary" />
                <h3 className="text-2xl font-semibold">Secure by Design</h3>
              </div>
              <p className="text-muted-foreground">
                We've built security into every layer of our platform. From encrypted communications 
                to strict access controls and regular security audits, your infrastructure is 
                protected at every level.
              </p>
            </div>
            
            {/* Expertise Feature */}
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Github className="w-8 h-8 text-primary" />
                <h3 className="text-2xl font-semibold">
                  Built by DevOps & Cybersecurity Experts
                </h3>
              </div>
              <p className="text-muted-foreground">
                Our team combines decades of experience in DevOps, cybersecurity, and AI development. 
                We've faced the same challenges you have and built NeurosEdge to solve them.
              </p>
              <Button 
                variant="outline" 
                className="border-primary/20 hover:bg-primary/10"
              >
                View Our Security Whitepaper
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
